import React from 'react';
import { motion } from 'framer-motion';

const HeroSection = () => {
  return (
    <section className="relative py-28 bg-primary overflow-hidden">
      {/* Background overlay with pattern */}
      <div className="absolute inset-0 opacity-20">
        <img 
          src="/images/agenzia1.jpeg" 
          alt="" 
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-primary/90 to-primary/80"></div>
      
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="container mx-auto px-4 relative z-10"
      >
        <div className="max-w-4xl mx-auto text-center text-white">
          <motion.div 
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1, delay: 0.2 }}
            className="inline-block mb-4"
          >
            <img 
              src="/logo_molinaro.png" 
              alt="Molinaro Immobiliare" 
              className="h-24 md:h-32 brightness-0 invert mx-auto"
            />
          </motion.div>
          <h1 className="text-5xl md:text-6xl font-monomakh mb-6 leading-tight">La Nostra Storia</h1>
          <p className="text-xl md:text-2xl text-gray-200 max-w-3xl mx-auto leading-relaxed">
            Dal 2017, Molinaro Immobiliare trasforma case in luoghi da vivere,
            unendo tradizione, innovazione e una profonda conoscenza del territorio.
          </p>
          
          <motion.div 
            initial={{ width: 0 }}
            animate={{ width: "100px" }}
            transition={{ delay: 0.5, duration: 0.8 }}
            className="h-1 bg-secondary mx-auto mt-8"
          ></motion.div>
        </div>
      </motion.div>
    </section>
  );
};

export default HeroSection;